import API from 'services/API';

export default function checkFacetStatus(retryNumber) {
  return API.request({
    method: 'GET',
    url: '/taxpayer/facetStatusData',
    params: { retryNumber },
  });
}
